import { t } from 'ttag'

import researchSvg from '@h2/assets/svg/blockGraphics/research.svg'

import { Promotion } from '../../promotion'

const Research = () => (
  <Promotion color="red" variant="explorer">
    <Promotion.Heading>{t`Do research`}</Promotion.Heading>
    <Promotion.Text>{t`Research your options and inform your choices.`}</Promotion.Text>
    <Promotion.Button href="/explore">{t`Start researching`}</Promotion.Button>
    <Promotion.Image src={researchSvg} />
  </Promotion>
)

export { Research }
